import { SettingsIcon, XIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { CardHeader } from "@/components/ui/card";

type HeaderProps = {
  headerProgressNumerator: number;
  /** 분모: 전체 세트 크기 또는 학습 덱 크기 */
  headerProgressDenominator: number;
  onBack: () => void;
  onOptions: () => void;
};

/** 진행 표시 규칙은 `flashcardProgress`·`CLAUDE.md` 참고. */
export function Header({ headerProgressNumerator, headerProgressDenominator, onBack, onOptions }: HeaderProps) {
  const progressLabel =
    headerProgressDenominator === 0 ? "0 / 0" : `${headerProgressNumerator} / ${headerProgressDenominator}`;

  return (
    <CardHeader className="flex items-center justify-between px-5">
      {/* 뒤로가기 버튼 */}
      <Button variant="ghost" size="icon" onClick={onBack}>
        <XIcon className="size-5 text-muted-foreground" />
      </Button>

      {/* 진행 (미분류·전체 세트 기준 또는 학습 덱 기준) */}
      <span className="text-sm font-semibold text-foreground">{progressLabel}</span>

      {/* 설정 버튼 */}
      <Button variant="ghost" size="icon" onClick={onOptions}>
        <SettingsIcon className="size-5 text-muted-foreground" />
      </Button>
    </CardHeader>
  );
}
